module.exports = __webpack_public_path__ + "img/funnelonhold.cfd175e0.svg";